import * as Sentry from '@sentry/react';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { ROUTES, SENTRY_DSN } from 'config/constants';
import { logout } from 'store/actions/auth.actions';
import { ConnectionError } from 'components/ConnectionError';
import { Button } from 'components/Button';

const AuthRoute = ({
  component: Component,
  authState = {},
  allowedStatuses,
  logout,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      const isAuthenticated = !!authState.isAuth || authState.isAdmin;

      if (!isAuthenticated) {
        const {
          location: { pathname = '/' },
        } = props;
        return <Redirect to={`${ROUTES.LOGIN}?redirectUrl=${pathname}`} />;
      }

      const { authInfo = {} } = authState;
      const { status, groups = [] } = authInfo;

      try {
        if (!!SENTRY_DSN) {
          Sentry.setUser({
            email: authInfo.email,
            id: authInfo.id,
          });
        }
      } catch (e) {
        console.error('Unable to register user info for sentry');
        console.error(e);
      }
      window.initializedAppcues.then((appcues) => {
        try {
          appcues.identify(authInfo.id, {
            role: authInfo.groups,
            firstName: authInfo.id,

            email: authInfo.email,
            location: authInfo.countryCode,
          });
        } catch (error) {
          console.error('APPCUES INITIALIZATION FAILED');
          console.error(error);
        }
      });

      if (
        !allowedStatuses ||
        ~allowedStatuses.indexOf(status) ||
        ~groups.indexOf('Admin')
      ) {
        return <Component {...props} />;
      }
      switch (status) {
        case 'Representative':
          return <Redirect to={`${ROUTES.REPRESENTATIVE_REGISTRATION}/1`} />;
        case 'ResearchSite':
          return <Redirect to={`${ROUTES.RESEARCH_SITE_FORM}/1`} />;
        case 'Sponsor':
          return <Redirect to={`${ROUTES.SPONSOR_STUDY_FORM}/1`} />;
        case 'PendingVerification':
          return <Redirect to={ROUTES.CONGRATULATION_ADMIN_VERIFICATION} />;
        case 'GrantedVerification':
          return <Redirect to={ROUTES.HOME_PAGE} />;
        case 'DeniedVerification':
          return <Redirect to={ROUTES.VERIFICATION_DECLINE} />;
        case 'Personnel':
          return <Redirect to={`${ROUTES.PERSONNEL_FORM}/1`} />;
        default:
          return (
            <ConnectionError>
              <div className="connection-error-page__text flex flex-column align-items-center">
                <div className="connection-error-page__title montserrat mt-8">
                  Ooops….something went wrong.
                </div>
                <div className="mt-3">Unexpected user status.</div>
                <div className="mt-6">
                  <Button
                    onClick={() => {
                      logout();
                    }}
                    className="_red"
                  >
                    Login again
                  </Button>
                </div>
              </div>
            </ConnectionError>
          );
      }
    }}
  />
);

AuthRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  authState: PropTypes.object,
  allowedStatuses: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = ({ authState }) => ({
  authState,
});

export default connect(mapStateToProps, { logout })(AuthRoute);
